import type { NoyauCode } from '@rosetta/shared';
import { FiltreNoyaux } from './filtre-noyaux';
import { IconeHistorique } from './icone-historique';

interface EnteteHistoriqueProps {
  recherche: string;
  onRecherche: (recherche: string) => void;
  noyaux: readonly NoyauCode[];
  onNoyaux: (noyaux: NoyauCode[]) => void;
}

/**
 * The header of the history, fixed over the list that scrolls: it is outside the scrolling
 * zone, which starts at the cards. The title and the intro on their own line, then the
 * toolbar, always there, even when the history is empty: the search and the noyau filter
 * ("nouveau texte" is the dashed card at the head of the grid).
 */
export function EnteteHistorique({
  recherche,
  onRecherche,
  noyaux,
  onNoyaux,
}: EnteteHistoriqueProps) {
  return (
    <header className="shrink-0 pr-4">
      <h1 className="text-h2 leading-[1.2]">
        <span className="font-bold">Historique</span>{' '}
        <span className="font-light">de vos traductions</span>
      </h1>
      <p className="mt-2 font-light text-body text-gray-700 leading-[1.55]">
        Retrouvez les textes que vous avez traduits et rouvrez leur résultat.
      </p>
      <div className="mt-6 flex items-center gap-3">
        <label className="relative block w-[400px]">
          <IconeHistorique
            name="search"
            className="pointer-events-none absolute top-3 left-3 text-gray-600"
          />
          <input
            type="search"
            aria-label="rechercher dans l'historique"
            placeholder="Rechercher un titre ou un texte"
            value={recherche}
            onChange={(evenement) => onRecherche(evenement.target.value)}
            className="h-10 w-full rounded-md border border-gray-500 bg-white pr-3 pl-12 text-black text-small placeholder:text-gray-600"
          />
        </label>
        <FiltreNoyaux valeur={noyaux} onChange={onNoyaux} />
      </div>
    </header>
  );
}
